module.exports = __webpack_public_path__ + "static/media/Sallie_tail2.82fe4f70.gif";